<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="600px"
  >
    <v-form @submit.prevent.native="submit">
      <v-card>
        <v-card-title>
          <v-toolbar-title>{{ this.title }}</v-toolbar-title>
          <v-spacer />
          <v-btn text icon color="white" @click="closeDialog">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-3">
          <v-container class="pa-2">
            <v-alert
              :value="true"
              type="error"
              class="mb-4"
              v-if="this.isEmptyName"
            >
              Veuillez remplir le champ "Nom".
            </v-alert>
            <v-text-field
              v-model="name"
              label="Nom"
              outlined
              required
              autofocus
              color="primary darken-1"/>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">Annuler</v-btn>
          <v-btn
            color="primary darken-1"
            @click="submit"
            :loading="isSaving"
          >
            {{ this.isUpdating ? `Modifier` : `Ajouter` }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: `SavePriority`,
  props: {
    value: Boolean,
    priority: {
      type: Object,
      required: false,
    },
    maker: Object,
  },
  data: () => ({
    name: ``,
    isSaving: false,
    isEmptyName: false,
  }),
  computed: {
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
    isUpdating() {
      return this.priority && this.priority.id;
    },
    title() {
      return this.isUpdating ? `Modifier une priorité` : `Ajouter une priorité`;
    },
  },
  methods: {
    initLocalState() {
      if (this.isUpdating) {
        this.name = this.priority.name;
      } else {
        this.name = ``;
      }
      this.isSaving = false;
      this.isEmptyName = false;
    },
    async submit() {
      this.isSaving = true;
      if (this.name.length === 0) {
        this.isEmptyName = true;
        this.isSaving = false;
      } else {
        const priority = await this.$store.dispatch(this.isUpdating ? `model/priority/savePriority` : `model/priority/addPriority`, {
          id: this.isUpdating ? this.priority.id : ``,
          name: this.name,
          makerId: this.maker?.id,
        });
        this.isSaving = false;
        this.isOpened = false;
        this.$emit(`save`, priority);
      }
    },
    closeDialog() {
      this.isOpened = false;
      this.$emit(`close`);
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initLocalState();
      }
    },
  },
};
</script>
